import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { SessionService } from './session.service';
import { Router } from '@angular/router';
import { SnackbarService } from './snackbar.service';
import { TranslocoService } from '@jsverse/transloco';
import { ConfigService } from './config/config.service';

@Injectable({
	providedIn: 'root',
})
export class DevService {
	translocoService = inject(TranslocoService);
	private keycloakService = inject(KeycloakService);
	private configService = inject(ConfigService);
	private route = inject(Router);
	private snackbar = inject(SnackbarService);
	private sessionService = inject(SessionService);

	private impersonationSubject = new Subject<any>();
	private companyStyleSubject = new Subject<any>();

	sendImpersonationEvent() {
		this.impersonationSubject.next(1);
	}

	getImpersonationEvent(): Observable<any> {
		return this.impersonationSubject.asObservable();
	}

	exchangeKeycloakToken(token) {
		// keycloak-angular v22 removed KeycloakService.init(). The single keycloak-js instance
		// (provideKeycloak + the startup APP_INITIALIZER) is already initialized and cannot be
		// re-init()'d, so swap the impersonation tokens on the live instance and force a refresh
		// (updateToken(-1)) instead — preserves the previous dev-impersonation behaviour.
		const keycloak = this.keycloakService.getKeycloakInstance();
		keycloak.token = token.access_token;
		keycloak.refreshToken = token.refresh_token;
		keycloak.idToken = token.id_token;
		keycloak.updateToken(-1).then(() => {
			this.sessionService.updateSession(false);
			this.sessionService.isImpersonatedSession = true;
			this.sendImpersonationEvent();
			this.route.navigate(['/dashboard']).then(() => {
				this.snackbar.success(this.translocoService.translate('settings.devSettings.supportTools.userImpersonated'));
			});
		});
	}

	sendCompanyStyleEvent(company: string) {
		this.companyStyleSubject.next(company);
	}

	getCompanyStyleEvent(): Observable<any> {
		return this.companyStyleSubject.asObservable();
	}
}
